import API from '../apiCreate'

export const emailProviderIntegrationApi = {
  getEmailProvider: (provider: string) =>
    API.get(
      `/integration-configs/get-email-provider?provider=${encodeURIComponent(
        provider,
      )}`,
    ),
  getEmailProviderOptions: (data: unknown) =>
    API.post(`/integration-configs/get-email-provider-options`, data),
  connectEmailProvider: (data: unknown) =>
    API.post(`/integration-configs/connect-email-provider`, data),
  /** Список email-провайдеров (уведомления / рассылки). */
  getEmailProviders: () => API.get(`trigger-notification/email-providers`),
  /** Список SMS-провайдеров (уведомления). */
  getSmsProviders: () => API.get(`trigger-notification/sms-providers`),
}
